import React, { useState, useEffect } from 'react';
import Overlay from '../overlay/default';
import WhoAreWe from '../whoAreWe/default';

const Home = () => {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const response = await fetch('https://ocdnewyork.org/wp/wp-json/wp/v2/pages');
      const data = await response.json();
      setPages(data);
    }

    fetchData();
  }, []);

  useEffect(() => {
    const toggleButtons = document.querySelectorAll('.open');
    const hiddenContent = document.querySelector('.overlay');
    const hiddenContentBg = document.querySelector('.overlay-bg');
    const hiddenCloseBtn = document.querySelector('.close');
    console.log(toggleButtons);
    console.log(hiddenContent);
    console.log(hiddenContentBg);
    if (hiddenContentBg) {
      hiddenContentBg.addEventListener("click", () => {
        hiddenContentBg.classList.remove("show");
        hiddenContent.classList.remove("show");
      });
      hiddenCloseBtn.addEventListener("click", () => {
        hiddenContentBg.classList.remove("show");
        hiddenContent.classList.remove("show");
      });
      toggleButtons.forEach(button => {
        button.addEventListener('click', () => {
          console.log('clicked', hiddenContent);
          hiddenContentBg.classList.add('show');
          hiddenContent.classList.add('show');
          console.log('clicked after', hiddenContent);
        });
      });
      
    }
  }, []);
  

  return (
    <>
      <div className="homepageTop"></div>
      <div className="homepage">
        <div class="content">
          <h2 >What is OCD?</h2>
          <div class="open"><div>
            <p>Learn more about OCD</p>
          </div></div>
          <p></p>
        </div><div class="overlay-bg"></div><div class="overlay"><div class="close">X</div><div>
          <h2>Obsessions:</h2>
          <ul>
            <li>Thoughts, images, or impulses that occur over and over again and feel out of the person’s control.</li>  <li>The person does not want to have these ideas.</li>
            <li>He or she finds them disturbing and unwanted, and usually know that they don’t make sense.</li>
            <li>They come with uncomfortable feelings, such as fear, disgust, doubt, or a feeling that things have to be done in a way that is “just right.”</li>
            <li>They take a lot of time and get in the way of important activities the person values.</li>
          </ul>
          <h2>What Obsessions Are Not:</h2>
          <ul>
            <li>It is normal to have occasional thoughts about getting sick or about the safety of loved ones.</li>
          </ul>
          <h2>Compulsions:</h2>
          <ul>
            <li>Repetitive behaviors or thoughts that a person engages in to neutralize, counteract, or make their obsessions go away.</li>
            <li>People with OCD realize this is only a temporary solution, but without a better way to cope, they rely on the compulsion as a temporary escape.</li>
            <li>Compulsions can also include avoiding situations that trigger obsessions.</li>
            <li>Compulsions are time consuming and get in the way of important activities the person values.</li>
          </ul>
          <h2>What Compulsions Are Not:</h2>
          <ul>
            <li>Not all repetitive behaviors or “rituals” are compulsions. For example, bedtime routines, religious practices, and learning a new skill involve repeating an activity over and over again, but are a welcome part of daily life.</li>
            <li>Behaviors depend on the context: Arranging and ordering DVDs for eight hours a day isn’t a compulsion if the person works in a video store.</li>
          </ul>
          <h2>WHAT IS THE TREATMENT FOR OCD?</h2>
          <ul>
            <li>Cognitive Behavior Therapy</li>
            <li>Medication</li>
            <li>Psychoeducation</li>
            <li>Family training and therapy</li>
          </ul>
          <h2>Overview of Cognitive Behavior Therapy</h2>
          <ul>
            <li>Cognitive Behavior Therapy, also called CBT, is an effective treatment for OCD.</li>
            <li>About 7 out of 10 people with OCD will benefit from either CBT or medicine. For the people who benefit from CBT, they usually see their OCD symptoms reduced by 60-80%.</li>
            <li>For CBT to work, a patient must actively participate in the treatment. Unfortunately, about 1 in 4 OCD patients refuse to do CBT.</li>
            <li>There are different kinds of CBT, but the one that works best for OCD is a kind called Exposure and Response Prevention, or ERP.</li>
          </ul>
          <h2>How is CBT different from traditional talk therapy (psychotherapy)?</h2>
          <ul>
            <li>Traditional talk therapy (or psychotherapy) tries to improve a psychological condition by helping the patient gain “insight” into their problems. Although this approach may be of benefit at some point in a OCD patient’s recovery, it is important that people with OCD try Cognitive Behavior Therapy (CBT) first, as this is the type of treatment that has been shown to be the most effective.</li>
          </ul>
          <h2>What is Exposure and Response Prevention (ERP)?</h2>
          <ul>
            <li>CBT is made up of many different kinds of therapies. The most important therapy in CBT for OCD is called “Exposure and Response Prevention” (ERP).</li>
            <li>The “Exposure” in ERP refers to confronting the thoughts, images, objects and situations that make a person with OCD anxious.</li>
            <li>The “Response Prevention” in ERP refers to making a choice not to do a compulsive behavior after coming into contact with the things that make a person with OCD anxious.</li>
            <li>This strategy may not sound right to most people. Those with OCD have probably confronted their obsessions many times and tried to stop themselves from doing their compulsive behavior, only to see their anxiety skyrocket. With ERP, a person has to make the commitment to not give in and do the compulsive behavior until they notice a drop in their anxiety. In fact, it is best if the person stays committed to not doing the compulsive behavior at all. The natural drop in anxiety that happens when you stay “exposed” and “prevent” the “response” is called habituation.</li>
          </ul>
          <h2>Another Way to Think About ERP:</h2>
          <ul>
            <li>If you begin to think of anxiety as information, what information is it giving you when it’s present? That you are in danger – or more accurately, that you might be in danger. “Might be” in danger is important to consider here.</li>
            <li>The experience of anxiety does not feel like a “might”, it feels like a truth: “I am in danger”. This is one of the most cruel parts of this disorder. It has taken over your alarm system, a system that is there to protect you.</li>
            <li>When you are facing an actual danger, say crossing a street and seeing a truck speeding toward you, your brain puts out information that you are in danger by making you feel anxious. The anxiety creates motivation to do something to protect yourself. The behaviors you engage in to protect yourself can actually save your life, for example getting out of the way of the oncoming truck! Unfortunately, in OCD your brain tells you that you are in danger a lot, even in situations where you “know” that there is a very small likelihood that something bad might happen.</li>
            <li>Now consider your compulsive behaviors as your attempts to keep yourself safe when you “might be” in danger. What are you telling your brain when you try to protect yourself?—That you must be in danger. In other words, your compulsive behavior fuels that part of your brain that gives out to many unwarranted danger signals. In order to reduce your anxiety and your obsessions, you have to stop the compulsive behavior. What do you have to risk by not protecting yourself? It feels like you are choosing to put yourself in danger. Exposure and Response Prevention changes your OCD and changes your brain because you actually find out whether you were in real danger or not.</li>
          </ul>
        </div></div></div>
      <WhoAreWe />
    </>
  );
}

export default Home;